import { GetterTree } from 'vuex';
import { BillingState } from '@monolith/legacy/store/account/billing/index';
import { AnkorstoreBillingExport } from '@client/api-internal/data-contracts';

export const getters: GetterTree<BillingState, unknown> = {
  hasExportList: (state: BillingState): boolean => {
    return !!state.exportList.length;
  },
  getExportList: (state: BillingState): AnkorstoreBillingExport[] => state.exportList,
  hasFinanceContact: (state: BillingState): boolean => state.hasFinanceContact,
  getMostRecentExport: (state: BillingState): AnkorstoreBillingExport | undefined => {
    // Find the most recent export in the list with the most long expiration date
    const mostRecentExport = state.exportList[state.exportList.length - 1];

    if (!mostRecentExport) {
      return null;
    }
    // check that expiration date is after today
    if (mostRecentExport && new Date(mostRecentExport.expiresAt) > new Date()) {
      return { ...mostRecentExport };
    } else {
      return null;
    }
  },
};
